<template>
  <hic-dialog append-to-body @open="open" :close-on-click-modal="false" :visible="visible" width="80%" title="检治集编辑" @close="cancel">
    <el-collapse style="padding: 5px; padding-right: 15px" :value="['1', '2', '3']">
      <el-collapse-item title="检治集信息" name="1" class="f-w">
        <el-form :inline="false" :model="value" :rules="comRules" ref="editor" label-width="6rem" label-position="right" class="left">
          <el-row>
            <el-col :span="8">
              <el-form-item label="名称" prop="name">
                <el-input type="text" placeholder="请输入名称" v-model.trim="value.name" auto-complete="new-account" />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="编码" prop="code">
                <el-input type="text" placeholder="请输入编码" v-model.trim="value.code" auto-complete="new-account" />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="类型" prop="type">
                <hic-dict-selector v-model="value.type" isEnum dict-type="examineStandardType" />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="助记码" prop="shortCode">
                <el-input type="text" placeholder="请输入助记码" v-model.trim="value.shortCode" auto-complete="new-account" />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="备注" prop="memo">
                <el-input type="text" placeholder="请输入备注" v-model.trim="value.memo" auto-complete="new-account" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>

      <el-collapse-item name="2" class="left f-w">
        <template slot="title">
          <el-row class="f-w">
            <el-col :span="8">
              检治集详情：
              <el-tooltip content="请添加单据细目！" placement="top" effect="dark">
                <el-button type="primary" icon="el-icon-plus" size="mini" title="添加项目" @click.stop="createRow" :disabled="editing">添加</el-button>
                {{ editing }}
              </el-tooltip>
            </el-col>
          </el-row>
        </template>

        <el-table class="mainTable" height="350" :data="items" v-loading="loading">
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button type="success" icon="el-icon-check" title="保存" circle plain size="mini" @click="saveRow(scope.row)" v-if="scope.row.isEditing"></el-button>
              <el-button type="warning" icon="el-icon-close" title="取消" circle plain size="mini" @click="cancelRow(scope.row, scope.$index)" v-if="scope.row.isEditing"></el-button>
              <el-button type="primary" icon="el-icon-edit" title="编辑" circle plain size="mini" @click="editRow(scope.row)" v-if="!scope.row.isEditing" :disabled="editing"></el-button>
              <el-button type="danger" icon="el-icon-delete" title="删除" circle plain size="mini" @click="delRow(scope.row, scope.$index)" v-if="!scope.row.isEditing" :disabled="editing"></el-button>
            </template>
          </el-table-column>

          <el-table-column label="项目名称" fixed="left" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <examineCode-select @change="examineCodeChange($event, scope.row)" :items="items" v-if="scope.row.isEditing" size="small" :condition="condition" v-model="scope.row" />
              <span v-else>{{ scope.row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="检治项目" min-width="100" align="right">
            <template slot-scope="scope">
              <hic-dict-selector isEnum v-if="scope.row.isEditing" v-model="scope.row.type" dict-type="examineStandardType" />

              <span v-else>{{ scope.row.type }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数量" min-width="100" align="right">
            <template slot-scope="{ row }">
              <el-input v-if="row.isEditing" type="number" size="small" v-model.number="row.quantity"></el-input>
              <span v-else>{{ row.quantity | fmtFloat }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>

    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">关 闭</el-button>
    </div>
  </hic-dialog>
</template>

<script>
import api from './api';
import { mapGetters } from 'sw-hic';
export default {
  props: {
    visible: Boolean,
    value: Object,
  },
  components: {
    'examineCode-select': () => import('./examineCodeSelect'),
  },
  data() {
    return {
      loading: false,
      editing: false,
      condition: {
        keyword: null,
        deptCode: null,
        pageIndexOnView: 1,
        pageSize: 20,
      },
      detailEmpty: {},
      items: [],
      comRules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: '请输入编码',
            trigger: 'blur',
          },
        ],
        type: [
          {
            required: true,
            message: '请选类型',
            trigger: 'change',
          },
        ],
      },
      disabledSave: false,
      synDisabledSave: false,
      deptFilterKey: null,
    };
  },
  computed: {
    ...mapGetters(['dict', 'user', 'dictEnum']),
  },
  created() {
    this.open();
  },
  methods: {
    editRow(row) {
      this.$set(row, 'isEditing', true);
      this.editing = true;
    },
    delRow(row, index) {
      let _this = this;
      api.SetDetailId.del(row.id).then(res => {
        _this.items.splice(index, 1);
      });
    },
    cancelRow(row, index) {
      if (!row.id) {
        this.items.splice(index, 1);
      }
      this.$set(row, 'isEditing', false);
      this.editing = false;
    },
    async saveRow(row) {
      let _this = this;
      if (!row.type) {
        this.$message.error('项目类型不能为空!');
        return;
      }
      if (!row.quantity) {
        this.$message.error('数量不能为空!');
        return;
      }
      let { name, code, shortCode, memo, id, type } = this.value;
      try {
        let examineSet = await api.ExamineSet.save({
          name,
          code,
          shortCode,
          memo,
          id,
          type,
        });
        let res = await api.SetDetailId.query({
          name: row.name,
          setCode: code,
          type: row.type,
          code: row.code,
          quantity: row.quantity,
          id: row.id,
        });
        row.id = res.id;
        _this.value.id = examineSet.id;
        _this.$set(row, 'isEditing', false);
        _this.editing = false;
        _this.$message.success('保存成功');
      } catch (error) {
        this.$message.error(error);
      }
    },
    newDetail() {
      return { quantity: 1, isEditing: true };
    },
    createRow() {
      this.$refs.editor
        .validate()
        .then(valid => {
          if (valid) {
            this.editing = true;
            this.condition.type = this.value.type;
            this.items.unshift(this.newDetail());
          }
        })
        .catch(err => {});
    },
    open() {
      this.items = [];
      this.editing = false;
      if (this.value.id) {
        this.loading = true;
        api
          .SetDetailId.query({ setCode: this.value.code })
          .then(res => {
            this.items = res.items;
          })
          .catch(err => {
            this.$message.error(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    cancel() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
    },
    deptFilter(key) {
      this.deptFilterKey = key;
      this.$utils.log(key);
    },
    save() {
      this.$refs.editor.validate().then(valid => {
        if (valid) {
          this.disabledSave = true;
          api
            .Standard.save(this.value)
            .then(res => {
              this.$message.success('保存成功!');
              this.$emit('ok');
              this.cancel();
            })
            .catch(err => {
              this.$message.error(err);
            })
            .finally(() => {
              this.disabledSave = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  justify-content: center;
}
</style>
